import { render, staticRenderFns } from "./SetupDetails.vue?vue&type=template&id=6e34afce&scoped=true&"
import script from "./SetupDetails.vue?vue&type=script&lang=js&"
export * from "./SetupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e34afce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e34afce')) {
      api.createRecord('6e34afce', component.options)
    } else {
      api.reload('6e34afce', component.options)
    }
    module.hot.accept("./SetupDetails.vue?vue&type=template&id=6e34afce&scoped=true&", function () {
      api.rerender('6e34afce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Start/SetupDetails.vue"
export default component.exports